<template lang="pug">
  .text-xs-center
    v-dialog(v-model='dialog', width='500')
      v-card.dialog-container
        v-card-actions
          v-spacer
          span.ap-cross(@click='dialog = false')
        .ap-Icono-app
        v-card-text.dialog-title Instala Asu Participa
        v-card-text.content-text
          | Instala la aplicación para un rápido acceso desde la pantalla inicial de tu teléfono.
        v-divider
        v-card-text.grey.lighten-2.content-text-footer.dialog-footer
          span.dialog-footer-text
            span Selecciona
            span.ap-Upload-ios
            span y luego "Agregar a la pantalla de inicio"
            span.ap-Add-ios
</template>

<script>
export default {
  data () {
    return {
      dialog: true
    }
  }
}
</script>

<style lang="stylus" scoped>
  .dialog-title
    color: #0d2563;
    font-weight: bold;
    font-size: 1.7rem;
  div
    text-align: center;
    font-family: Raleway;
  .ap-Icono-app
    color: #00a64f;
    font-size: 5vmax;
    @media (max-width: 600px)
      font-size: 10vmax;
  .ap-Upload-ios
    color: #2b7fe3;
  .ap-Add-ios, .ap-cross
    color: #636368;
  .dialog-container
    border-radius: 5px;
  .content-text
    font-size: 1.2rem;
    margin-bottom: 32px;
  @media screen and (max-width: 350px)
    .content-text-footer
      font-size: 0.6rem;
      align-items: center;
      padding: 16px 4px;
  @media screen and (min-width: 351px) and (max-width: 400px)
    .content-text-footer
      font-size: 0.8rem;
      align-items: center;
      padding: 16px 4px;
  @media screen and (min-width: 401px)
    .content-text-footer
      font-size: 0.9rem;
      align-items: center;
      padding: 16px 4px;
  .ap-Upload-ios, .ap-Add-ios
    padding 0 5px;
    font-size: 1rem;
    margin: 5px 0;
  .dialog-footer
    display: flex;
    justify-content: center;
  .ap-cross
    padding: 10px;
    cursor: pointer;
  .dialog-footer-text
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
</style>
